interface PeoplyLogoProps {
  className?: string;
  id?: string;
  'aria-hidden'?: boolean | 'true' | 'false';
}

export const PeoplyLogo = ({ className = 'w-6 h-6', id, 'aria-hidden': ariaHidden }: PeoplyLogoProps) => (
  <img
    id={id}
    src='/peoply-icon.svg'
    alt='Peoply'
    className={className}
    aria-hidden={ariaHidden}
  />
);
